import { render, staticRenderFns } from "./tableInvite.vue?vue&type=template&id=0585f57e&scoped=true&slot-scope=scope&"
import script from "./tableInvite.vue?vue&type=script&lang=js&"
export * from "./tableInvite.vue?vue&type=script&lang=js&"
import style0 from "./tableInvite.vue?vue&type=style&index=0&id=0585f57e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0585f57e",
  null
  
)

export default component.exports